module.exports = __webpack_public_path__ + "static/media/banner-bg.027da98e.jpg";